import CryptoJS from 'crypto-js';
import base64 from 'crypto-js/enc-base64';
import md5 from 'crypto-js/md5';
import { type UploadImagePayload } from '@fsd/shared/api';

export const handleImageUpload = async (file: File) => {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = function (event) {
      const imageData = event.target!.result;

      const fileContent = CryptoJS.lib.WordArray.create(imageData as ArrayBuffer);
      const checksum = base64.stringify(md5(fileContent));

      resolve(checksum);
    };

    reader.readAsArrayBuffer(file);
  });
};

export const createBlobFile = ({ imageData }: { imageData: string }) => {
  const binary = atob(imageData.split(',')[1]);
  const mimetype = imageData.split(',')[0].split(':')[1].split(';')[0];

  const array = [];
  for (let i = 0; i < binary.length; i += 1) {
    array.push(binary.charCodeAt(i));
  }

  return new Blob([new Uint8Array(array)], { type: mimetype });
};

export const readeFromBlob = (file: File): Promise<Blob> => new Promise((resolve) => {
  const reader = new FileReader();

  reader.onload = function (event) {
    const imageData = event.target!.result as string;
    const imagesData = createBlobFile({ imageData });
    resolve(imagesData);
  };

  reader.readAsDataURL(file);
});

const fetchRequest = async ({ params, imagesData }: { params: UploadImagePayload, imagesData: Blob }) => {
  const headers = {
    'Content-MD5': params.checksum,
    'Content-Type': params.contentType,
    'Content-Length': String(params.contentLength),
  };

  return fetch(params.uploadUrl, {
    method: 'PUT',
    headers,
    body: imagesData,
  });
};

export const uploadImages = async ({ file, params }: { file: File, params: UploadImagePayload }) => {
  const imagesData = await readeFromBlob(file);
  return fetchRequest({ params, imagesData });
};

export const conditionRejectedFile = (response: PromiseSettledResult<Response>) => {
  return response.status === 'rejected' || response.value.ok === false;
};
